import { useCallback } from "react";
import { useMISReportDownload } from "@hooks/useMISReportDownload";
import { MIS_FIELDS_TRAINWISEPERFORMANCE } from "@constants/misDownloadData";
import { ATP_API_URL } from "@config/apiconfig";

export const useTrainWisePerformanceDownload = () => {
  const dataMapper = useCallback(
    (item) => ({
      "Sr No": item.sr_no,
      "Train No": item.train_no || "",
      "Train Name": item.train_name || "",
      "Total Searches": item.total_searches || 0,
      "Probability Trend Avg (%)": item.probability_trend_avg || "0%",
      "Eligible Policies Offered": item.eligible_policies_offered || 0,
      "Policies Sold": item.policies_sold || 0,
      "Claims Triggered": item.claims_triggered || 0,
      "Claims %": item.claims_percentage || "-",
    }),
    [],
  );

  return useMISReportDownload({
    reportType: "train-wise-performance",
    reportName: "Train-wise Performance",
    fields: MIS_FIELDS_TRAINWISEPERFORMANCE,
    dataMapper,
    apiUrl: ATP_API_URL.MIS_TRAIN_PERFORMANCE,
    sheetName: "Train Performance",
  });
};

export default useTrainWisePerformanceDownload;
